import { type ITelemetryCustom, sendTelemetryEvent } from "@/lib/telemetry";

import Button from "../button";
import type { IButton } from "../button/button";

export type ITelemetryButtonProps = IButton & Partial<IButtonTelemetryProps>;
export type IButtonTelemetryProps = Omit<ITelemetryCustom, "actionType">;

export default function TelemetryButton({
    eventName,
    itemId,
    param1,
    param2,
    param3,
    param4,
    origin,
    channel,
    onClick,
    ...props
}: ITelemetryButtonProps) {
    return (
        <Button
            {...props}
            onClick={(event: React.MouseEvent<HTMLButtonElement> & React.MouseEvent<HTMLAnchorElement>) => {
                if (eventName) {
                    sendTelemetryEvent({
                        eventName,
                        itemId,
                        param1,
                        param2,
                        param3,
                        param4,
                        origin,
                        channel,
                        actionType: "Click",
                    });
                }

                if (onClick) return onClick(event);
            }}
        />
    );
}
